import React from 'react';
import bowser from 'yola-bowser';
import Box from '../box';
const DialogHeader = ({
  children,
  paddingTop = undefined,
  paddingBottom = undefined,
  paddingLeft = undefined,
  paddingRight = undefined,
}) => {
  const isMobile = bowser.mobile;
  const boxProps = {
    paddingTop: paddingTop || 'spacing-2-xs',
    paddingBottom: paddingBottom || 'spacing-2-xs',
    paddingLeft: paddingLeft || (isMobile ? 'spacing-xs' : 'spacing-m'),
    paddingRight: paddingRight || (isMobile ? 'spacing-xs' : 'spacing-m'),
  };

  return (
    <div className="ws-ui-dialog-header">
      <Box {...boxProps}>
        <div className="ws-ui-dialog-header__content">{children}</div>
      </Box>
    </div>
  );
};

export default DialogHeader;
